import React, { ReactNode } from 'react';

import Accordion from 'components/Accordion';
import TitleSemiBold from 'components/Typography/TitleSemiBold';

import './index.scss';

/** `eventKey` do item no accordion do painel (o painel abre o item por ele). */
export const EVENT_KEY_ESTUDO_AUTOMATICO = 'estudo-automatico';

interface EstudoAutomaticoProps {
  /** Sub-accordions agrupados dentro de "Estudo Automatico". O caller deve
   * passar `<RunType />`, `<Models />` e `<Rmv />` como children — eles ja
   * sao `<Accordion.Item>` proprios, entao o nested Accordion abaixo os
   * organiza visualmente como uma lista de sub-itens colapsaveis (estilo
   * Comparador Classico, secao "Modelo Confrontante"). */
  children: ReactNode;
}

/**
 * Accordion pai "Estudo Automatico" (WINDX-035; nas tres abas desde o WEOL-SM #99).
 *
 * Agrupa Tipo de Rodada + Modelos + RMV em um unico bloco colapsavel,
 * espelhando o padrao do Comparador Classico (`ModelAccordion`) — quando
 * o usuario abre "Estudo Automatico", ve a lista de sub-accordions.
 *
 * WINDX-062: o sub-accordion "Tipo de Rodada" (eventKey="run-type") ja vem
 * ABERTO por padrao (`defaultActiveKey="run-type"`) — e o primeiro passo do
 * fluxo (sem ele, Modelos/RMV ficam ocultos por WINDX-061), entao abrir
 * direto poupa um clique e deixa Preliminar/Final imediatamente visiveis.
 * O Accordion aninhado e single-open (`flush`), logo Modelos/RMV seguem
 * fechados ate o usuario escolher o tipo e clicar neles.
 *
 * **Nas tres abas** (WEOL-SM, windx-automatico#99): o Semanal e o Comparativo
 * passam a ter rodada preliminar e final e seguem o fluxo do SH (antes, PO
 * 2026-05-22, eram flat). Sem `tipos_rodada` no painel-options (flag do BE
 * desligada), o "Tipo de Rodada" nao vem e o bloco agrupa so Modelos + RMV —
 * e o painel abre o bloco ja aberto (`abrirEstudoAutomatico`, decisao do #99).
 *
 * Nao trata estado nem dispatch — apenas estrutura visual. Os filhos sao
 * `<Accordion.Item>` proprios e mantem todo o controle de redux+props.
 */
export default function EstudoAutomatico({ children }: EstudoAutomaticoProps) {
  return (
    <Accordion.Item eventKey={EVENT_KEY_ESTUDO_AUTOMATICO}>
      <Accordion.Header>
        <TitleSemiBold>Estudo Automático</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body className="windx-estudo-automatico-body">
        <Accordion defaultActiveKey="run-type">
          {children}
        </Accordion>
      </Accordion.Body>
    </Accordion.Item>
  );
}
